module.exports = __webpack_public_path__ + "static/img/mamanvogue-landing.1385de4.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mamanvogue-landing.webp
// module id = 117
// module chunks = 0